/**
 * Modal
 */
import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

const styles = {
  wrapper: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    textAlign: 'center',
    zIndex: 99999999,
    backgroundColor: 'rgba(0,0,0,.2)',
  },
  pseudoBefore: {
    content: '',
    display: 'inline-block',
    height: '100%',
    verticalAlign: 'middle',
  },
  outer: {
    position: 'relative',
    display: 'inline-block',
    verticalAlign: 'middle',
    maxWidth: '80%',
    margin: '0 auto',
    padding: 10,
    boxShadow: '0 0 20px 0 rgba(0, 0, 0, .5)',
    backgroundColor: 'white',
    borderRadius: 5,
  },
  title: {
    padding: 8,
    margin: '-10px -10px 0',
    fontSize: 18,
    color: 'white',
    textShadow: '2px 2px 0 rgba(0,0,0,.3)',
    backgroundColor: '#c00',
    borderRadius: '5px 5px 0 0',
  },
  content: {
    padding: 10,
  },
  show: {
    display: 'block',
  },
  hide: {
    display: 'none',
  },
};

class Modal extends React.Component {
  render() {
    const props = this.props;
    const visible = props.visible || false;
    const wrapperStyle = _.assign({}, styles.wrapper, visible ? styles.show : styles.hide);

    return (
      <div style={wrapperStyle}>
        <div style={styles.pseudoBefore} />
        <div style={styles.outer}>
          <h1 style={styles.title}>{props.title}</h1>
          <div style={styles.content}>
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }
}

Modal.propTypes = {
  visible: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
};

export default Modal;



// WEBPACK FOOTER //
// ./src/components/shared/Modal.js